/**
 * sendy-subscribe.js
 * Silently subscribes newsletter signups to Sendy WD-Welcome list
 * in parallel with the native Shopify form submission.
 * Does not interfere with Shopify's own form flow.
 */

(function () {
  var SENDY_URL = 'https://sharedmarketingdepartment.com/sendy/subscribe';
  var SENDY_LIST = 'f7saT8TydCiynzw8YvnfiA';

  function sendToSendy(email, name) {
    var params = new URLSearchParams();
    params.append('email', email);
    params.append('name', name || '');
    params.append('list', SENDY_LIST);
    params.append('subform', 'yes');
    params.append('boolean', 'true');
    params.append('hp', ''); // honeypot field, must be empty

    fetch(SENDY_URL, {
      method: 'POST',
      body: params,
      mode: 'no-cors'
    }).catch(function () {
      // Fail silently - Shopify form still completes regardless
    });
  }

  function attachToForm(form) {
    if (form.dataset.sendyAttached) return;
    form.dataset.sendyAttached = 'true';

    var submitBtn = form.querySelector('button[type="submit"], button[name="commit"]');
    if (!submitBtn) return;

    submitBtn.addEventListener('mousedown', function () {
      var emailInput = form.querySelector('input[type="email"], input[name="contact[email]"]');
      var nameInput = form.querySelector('input[name="contact[name]"], input[name="name"]');
      if (!emailInput || !emailInput.value) return;
      sendToSendy(
        emailInput.value.trim(),
        nameInput ? nameInput.value.trim() : ''
      );
    });
  }

  function attachToEcomSend() {
    var btn = document.getElementById('ecomsend-submit-button-353458');
    if (!btn || btn.dataset.sendyAttached) return;
    btn.dataset.sendyAttached = 'true';

    btn.addEventListener('click', function () {
      var popup = document.getElementById('Ecomsend_popups_open_353456');
      if (!popup) return;
      var emailInput = popup.querySelector('input[type="email"], #email');
      if (!emailInput || !emailInput.value) return;
      sendToSendy(emailInput.value.trim(), '');
    });
  }

  function initEcomSendWithRetry() {
    var attempts = 0;
    var maxAttempts = 30;
    var interval = setInterval(function () {
      attempts++;
      var btn = document.getElementById('ecomsend-submit-button-353458');
      if (btn && !btn.dataset.sendyAttached) {
        attachToEcomSend();
        clearInterval(interval);
      }
      if (attempts >= maxAttempts) clearInterval(interval);
    }, 2000);
  }

  function initAll() {
    document.querySelectorAll('form[id^="newsletter-"]').forEach(attachToForm);
    document.querySelectorAll('newsletter-popup form').forEach(attachToForm);
  }

  if (document.readyState !== 'loading') {
    initAll();
    initEcomSendWithRetry();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      initEcomSendWithRetry();
    });
  }

  document.addEventListener('page:loaded', function () {
    initAll();
    initEcomSendWithRetry();
  });

})();